export default [
  {
    text: 'Мероприятия',
    to: { name: 'activities-calendar' },
  },
];



// WEBPACK FOOTER //
// ./src/pages/menu.activities.js